import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InputValueProps from '../../../../../prop-types/input-value-props';
import { DatePicker } from 'ui-components/components/date-picker';
import Global from '../../../../../../../../store/global-selectors';
import { DateService } from '../../../../../../../../services/date-service';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const HoldUntil = ({ inputValueProps, onChange, hasError, label }) => {
  const dateFormat = useSelector(Global.selectUserUserDateFormat);
  const { parameter } = inputValueProps;
  const onValueChange = useCallback(
    (date) => {
      const serverPreferredFormat = DateService.getDateInFormatBackendRespects(date, dateFormat);
      onChange({
        [PARAMETER]: serverPreferredFormat,
      });
    },
    [onChange, dateFormat],
  );

  return (
    <div>
      <div
        className={classnames(style['multi-control-row'], {
          [style.error]: hasError,
        })}
      >
        <div>{label}</div>
        <div>
          <DatePicker
            additionalDateFormats={DateService.getAdditionalDateFormats()}
            allowPastDates={false}
            className={style['edit-date-picker']}
            dateFormat={dateFormat}
            onChange={onValueChange}
            value={parameter || ''}
          />
        </div>
      </div>
    </div>
  );
};

HoldUntil.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
};

export default HoldUntil;
